// import queryString from 'query-string';
import { isEnv } from './utils';
import { Query } from './util'

const searchquery = Query.decode(location.href).params
const env = searchquery.env
console.log('isEnv:', isEnv, process.env.NODE_ENV);
let dataApi = '//dpubstatic.udache.com/static/h5market/';

if (env === 'dev' || isEnv) {
    dataApi = 'http://10.90.28.42:8052/static/anything/';
}

function pAjax(s) {
    return new Promise((resolve, reject) => {
        try {
            window.D.utils.ajax({
                url: `${dataApi}${s}.json`,
                type: 'GET',
                success: (res) => {
                    resolve(res);
                },
                error: (err) => {
                    reject(new Error(err));
                },
            });
        } catch (err) {
            reject(new Error(err));
        }
    });
}

async function getData() {
    // let data = {}
    const s = searchquery.s
    if (s) {
        console.log('数据来源于接口请求');
        // eslint-disable-next-line no-useless-catch
        try {
            return await pAjax(s);
        } catch (err) {
            throw err;
        }
    } else if (isEnv) {
        console.log('数据来源于mockData');
        // eslint-disable-next-line no-useless-catch
        try {
            // eslint-disable-next-line global-require
            const mockData = require('../../../mockData');
            return mockData;
        } catch (err) {
            throw err;
        }
    } else {
        throw new Error(`can not fetch data in ${process.env.NODE_ENV}, please check your url, it mast have s in query`);
    }
    // return data
}

export default getData;
